<template>
  <div class="export-pdf">
    <!-- 导出按钮 -->
    <div class="export-btn-wrap" style="width: 1000px; margin-bottom: 20px; text-align: right;">
      <el-button
          type="primary"
          icon="el-icon-download"
          @click="handlePreciseExportPdf"
          :loading="exportLoading"
          :disabled="!questionList.length"
      >
        導出PDF
      </el-button>
    </div>
    <!-- PDF头部（用于渲染参考） -->
    <div id="pdfHeader" style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 10px 0;">
      <div style="width: 150px;"></div>
      <div style="display: flex; align-items: center; gap: 10px; justify-content: center;">
        <img
            :src="require('@/assets/images/bear3.png')"
            style="width: auto; height: 40px;"
        >
        <span style="font-size: 28px; font-weight: bold; color: black;">作業練習</span>
      </div>
      <div style="display: flex; justify-content: flex-end; width: 150px;">
        <span style="font-size: 12px; color: #9b9b9b;">{{homework.name}}</span>
      </div>
    </div>

    <!-- PDF导出容器 - 新增45度倾斜背景图 -->
    <div id="pdfDom" class="pdf-container">
      <div class="questions-container">
        <div
            class="component-wrapper question-item"
            v-for="(its, idx) in questionList"
            :key="idx"
            ref="questionItems"
            :data-index="idx"
        >
          <div class="question-content">
            <h2>{{ idx + 1 }}.題目：{{its.question_no}}</h2>
            <component :is="its.echo" :form="its" @onRenderComplete="mathjaxRes"></component>
          </div>
        </div>
      </div>
    </div>

    <!-- 复用单个临时容器 -->
    <div ref="tempContainer" style="position: fixed; top: -9999px; left: -9999px; width: 1000px; padding: 40px 50px; background: #fff; z-index: -1;"></div>
  </div>
</template>

<script>
import transform from './transition.js'
import { getHomeworksDetail } from "@/api/homeworks";
import { toSnakeCase } from '@/utils/data-format'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  components: { ...transform },
  data() {
    return {
      convertType: [
        'ChoiceEcho', 'DetermineEcho', 'FillingBlanksEcho', 'SumEcho',
        'HotspotEcho', 'TextDragEcho', 'LigatureEcho', 'ImgDragEcho',
        'SumEcho', 'TextDragEcho2'
      ],
      questionList: [],
      homework: {},
      htmlTitle: "測試導出文件",
      mathjaxNum: 0,
      currentTime: '',
      exportLoading: false,
      // 移除logo相关缓存
      cache: {
        headerCanvasData: null,
        headerHeight: 0,
        headerWidth: 0
      },
      // 优化后的PDF配置（移除logo相关配置）
      pdfConfig: {
        pageWidth: 210,    // A4宽度(mm)
        pageHeight: 297,   // A4高度(mm)
        marginBottom: 5,   // 每页底部留白(mm)
        usableHeight: 292, // 可用高度 = 297 - 5
        scale: 1.5,        // 降低缩放比例（平衡清晰度和速度）
        // Canvas优化参数
        canvasOptions: {
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
          async: true, // 开启异步渲染
          skipEmpty: true, // 跳过空元素
          removeContainer: false // 不删除临时容器
        }
      }
    }
  },
  async mounted() {
    this.formatCurrentTime()
  },
  methods: {
    mathjaxRes() { this.mathjaxNum++ },

    formatCurrentTime() {
      const date = new Date()
      this.currentTime = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    },

    // 移除logo加载方法

    // 缓存头部Canvas数据，只渲染一次
    async _loadHeader() {
      if (this.cache.headerCanvasData) return
      try {
        const headerEl = document.getElementById('pdfHeader')
        const tempContainer = this.$refs.tempContainer

        tempContainer.innerHTML = ''
        tempContainer.appendChild(headerEl.cloneNode(true))
        await this.$nextTick()

        const canvas = await html2Canvas(tempContainer, {
          ...this.pdfConfig.canvasOptions,
          scale: this.pdfConfig.scale
        })

        // 缓存头部数据（尺寸+图片）
        const scaleRatio = this.pdfConfig.pageWidth / canvas.width
        this.cache.headerWidth = this.pdfConfig.pageWidth
        this.cache.headerHeight = canvas.height * scaleRatio + 5
        this.cache.headerCanvasData = canvas.toDataURL('image/png', 1.0)

        // 清空临时容器
        tempContainer.innerHTML = ''
      } catch (error) {
        console.warn('头部加载失败：', error)
        this.cache.headerHeight = 20 // 兜底
      }
    },

    init(title, id) {
      this.htmlTitle = title
      this.formatCurrentTime()

      getHomeworksDetail(id).then(res => {
        res.data.questions.forEach(its => {
          its.echo = this.convertType[its.type]
        })
        this.homework = res.data
        this.questionList = toSnakeCase(res.data.questions)
      })
    },

    // 核心优化：批量预处理+减少重复渲染
    async handlePreciseExportPdf() {
      try {
        this.exportLoading = true
        const questionItems = this.$refs.questionItems
        const tempContainer = this.$refs.tempContainer

        if (!questionItems || !questionItems.length) {
          this.$message.warning('無導出內容！')
          return
        }

        // 第一步：预加载并缓存头部（只执行一次）
        await this._loadHeader()

        // 第二步：批量预处理所有题目（提前渲染Canvas，减少串行等待）
        console.log('开始预处理题目...')
        const questionCanvasList = []
        for (let i = 0; i < questionItems.length; i++) {
          const questionEl = questionItems[i]
          tempContainer.innerHTML = ''
          tempContainer.appendChild(questionEl.cloneNode(true))
          await this.$nextTick()

          // 优化Canvas渲染参数
          const canvas = await html2Canvas(tempContainer, {
            ...this.pdfConfig.canvasOptions,
            scale: this.pdfConfig.scale,
            width: tempContainer.offsetWidth,
            height: tempContainer.offsetHeight
          })

          // 计算题目尺寸并缓存
          const scaleRatio = this.pdfConfig.pageWidth / canvas.width
          questionCanvasList.push({
            imgData: canvas.toDataURL('image/jpeg', 0.9), // 降低质量提升速度
            width: this.pdfConfig.pageWidth,
            height: canvas.height * scaleRatio
          })
        }
        tempContainer.innerHTML = '' // 清空临时容器
        console.log('题目预处理完成，共', questionCanvasList.length, '题')

        // 第三步：生成PDF（使用缓存的Canvas数据）
        const pdf = new JsPDF('portrait', 'mm', 'a4')
        const usableHeightWithHeader = this.pdfConfig.usableHeight - this.cache.headerHeight
        let currentY = this.cache.headerHeight
        let pageNum = 1
        console.info(usableHeightWithHeader)
        // 渲染第一页头部
        this._renderPageHeader(pdf, 0)

        // 遍历预渲染的题目
        for (let i = 0; i < questionCanvasList.length; i++) {
          const q = questionCanvasList[i]

          // 判断是否需要分页
          if (currentY + q.height > this.pdfConfig.usableHeight) {
            pdf.addPage()
            this._renderPageHeader(pdf, 0)
            currentY = this.cache.headerHeight
            pageNum++
          }

          // 添加题目（使用缓存的imgData）
          pdf.addImage(q.imgData, 'JPEG', 0, currentY, q.width, q.height)
          currentY += q.height + 8 // 减少间距，提升效率
        }

        // 保存PDF
        const fileName = `${this.htmlTitle}_${this.currentTime}.pdf`
        pdf.save(fileName)
        this.$message.success(`導出成功！共${pageNum}页`)

      } catch (error) {
        console.error('导出失败详情：', error)
        this.$message.error(`導出失敗！`)
      } finally {
        this.$refs.tempContainer.innerHTML = ''
        this.exportLoading = false
      }
    },

    // 使用缓存的头部数据渲染
    _renderPageHeader(pdf, startY) {
      if (this.cache.headerCanvasData) {
        pdf.addImage(
            this.cache.headerCanvasData,
            'PNG',
            0,
            startY,
            this.cache.headerWidth,
            this.cache.headerHeight - 5,
            'FAST'
        )
      }
    },

    // 移除addLogoBackground方法
  },
  beforeDestroy() {
    if (this.$refs.tempContainer) {
      this.$refs.tempContainer.innerHTML = ''
    }
    // 清空缓存
    this.cache = {
      headerCanvasData: null,
      headerHeight: 0,
      headerWidth: 0
    }
  }
}
</script>

<style scoped lang="scss">
.export-pdf {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 30px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', sans-serif;
}

.pdf-container {
  width: 1000px;
  background-color: #ffffff;
  padding: 40px 50px;
  box-sizing: border-box;
}

.questions-container {
  position: relative;
  z-index: 1; /* 确保内容在背景图上方 */
}

.question-item {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  z-index: 1; /* 确保题目内容在背景图上方 */

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .question-content {
    font-size: 16px;
    line-height: 1.8;
    color: #303133;
    position: relative;
    z-index: 1;
    /* 核心：添加45度倾斜的背景图 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: url('~@/assets/images/logo.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 200px auto;
      opacity: 0.1;
      transform: rotate(-45deg); /* 背景图旋转45度 */
      pointer-events: none; /* 不影响鼠标事件 */
      z-index: 99999;
    }
    position: relative; /* 配合伪元素定位 */
    :deep(*) {
      font-size: inherit;
      line-height: inherit;
    }

    :deep(img) {
      max-width: 100%;
      height: auto;
    }
  }
}

@media (max-width: 1024px) {
  .pdf-container {
    width: 100%;
    padding: 30px 20px;
  }
}

@media (max-width: 768px) {
  .export-pdf {
    padding: 15px 10px;
  }
  .pdf-container {
    padding: 20px 15px;
  }
  .question-content {
    font-size: 14px;
  }
}
</style>

<style lang="scss" scoped>
.export-pdf {
  :deep(.question-view) {
    .block-style {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 80px;
      left: 80px;
      cursor: pointer;
      z-index: 1;
      background-size: 100% 100%;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
    }
  }
}
</style>